module.exports = __webpack_public_path__ + "img/5.4174ad46.png";